import { mouseFollowWhenVisible } from "../utilities/mouse-follow";
import { getAll } from "../utilities/querySelector";

getAll( '.laypan' ).forEach( mouseFollowWhenVisible);